import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt alle Regeln zurück.
 */
export function getRules(): JQueryPromise<modelsGet.IRule[]>
{
    var endpoint = new URI("api/rules");

    return api.get<modelsGet.IRule[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Regeln für Trauerhallen zurück.
 */
export function getRulesForMourningHall(): JQueryPromise<modelsGet.IRuleMourningHall[]>
{
    var endpoint = new URI("api/rules/mourning-halls");

    return api.get<modelsGet.IRuleMourningHall[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt eine Regel für Trauerhallen anhand einer ID zurück.
 */
export function getRuleForMourningHall(id: number): JQueryPromise<modelsGet.IRuleMourningHall>
{
    var endpoint = new URI("api/rules/mourning-halls/" + id.toString());

    return api.get<modelsGet.IRuleMourningHall>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt eine Regel anhand einer ID zurück.
 */
export function getRule(id: number): JQueryPromise<modelsGet.IRule>
{
    var endpoint = new URI("api/rules/" + id.toString());

    return api.get<modelsGet.IRule>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(jsonData: modelsPost.IRule): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/rules",
        data: JSON.stringify(jsonData)
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function postRuleForMourningHall(jsonData: modelsPost.IRuleMourningHall): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/rules/mourning-halls",
        data: JSON.stringify(jsonData)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, jsonData: modelsPost.IRule): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/rules/${id}`,
        data: JSON.stringify(jsonData)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function putRuleForMourningHall(id: number, jsonData: modelsPost.IRuleMourningHall): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: `api/rules/mourning-halls/${id}`,
        data: JSON.stringify(jsonData)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/rules/${id}`
    });
}